var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cargo-cascader" },
    [
      _c("el-cascader", {
        ref: "elCascader",
        class: _vm.canCopy ? "can-copy" : "",
        attrs: {
          value: _vm.value,
          disabled: _vm.disabled,
          options: _vm.options,
          filterable: _vm.filterable,
          placeholder: _vm.placeholder,
          props: { multiple: true },
          separator: "-",
          "collapse-tags": "",
          clearable: ""
        },
        on: { input: _vm.onInput, "visible-change": _vm.onVisibleChange },
        nativeOn: {
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.onEnter($event)
          }
        }
      }),
      _vm.canCopy
        ? _c(
            "el-tooltip",
            {
              attrs: {
                content: _vm.$t("CargoMsg.Cargo_Copy"),
                placement: "top"
              }
            },
            [
              _c(
                "el-link",
                {
                  staticClass: "copy-icon",
                  attrs: { underline: false },
                  on: { click: _vm.handleCopy }
                },
                [_c("i", { staticClass: "el-icon-document-copy" })]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }